import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { BsButton } from '../collection/bootstrap/BootstrapComponents';
import { useLoad } from '../collection/Hooks';
import Loading from '../collection/icons/Loading';
import FicharModal from '../components/modals/FicharModal';
import { apiGet } from '../utils/api';
import { formatTimeSpan } from '../utils/functions';
import Calendario from './info/Calendario';

export default function Home(props) {
    const [jornadaActual, setJornadaActual] = useState();
    const [jornadaSemanal, setJornadaSemanal] = useState();
    const [isLoading, setIsLoading] = useState(true);

    // get data
    const [jornada, reload] = useLoad(async () => {
        const value = await apiGet("fichajes/getJornada");
        if (value.jornadaActual) await setJornadaActual(value.jornadaActual);
        if (value.jornadaSemanal) await setJornadaSemanal(value.jornadaSemanal);
        const value2 = await apiGet("convenios/actualizar");
        await setIsLoading(false);
        return value;
    });

    // timer
    useEffect(() => {
        setInterval(() => reload(), 15000);
    }, []);

    // modal
    const [modalShow, setModalShow] = useState(false);
    const showModal = () => setModalShow(true);
    const hideModal = () => {
        setModalShow(false);
        reload();
    }

    return jornada ? <>
        <div className="d-flex align-items-center justify-content-center gap-3">
            <BsButton
                title="Fichar" size="lg"
                variant={isLoading ? "secondary" : jornada.estaTrabajando ? "danger" : "success"}
                isLoading={isLoading} onClick={showModal}>
                <FontAwesomeIcon icon={jornada.estaTrabajando ? faPause : faPlay} />
            </BsButton>
            <table className="text-end">
                <tr>
                    <td>Fichaje actual:</td><td>{formatTimeSpan(jornadaActual, "^Hh ^m")}min</td>
                </tr>
                <tr>
                    <td>Jornada semanal:</td><td>{formatTimeSpan(jornadaSemanal, "^Hh ^m")}min</td>
                </tr>
            </table>
        </div>
        <Calendario mine key="home" className="mt-3" />
        <FicharModal isNew show={modalShow} onHide={hideModal} notifyOk />
    </> : <Loading />;
}
